import { render } from "./Other.vue?vue&type=template&id=a16e9d54"
import script from "./Other.vue?vue&type=script&lang=js"
export * from "./Other.vue?vue&type=script&lang=js"
script.render = render

export default script